import React from "react";

const state = {
  inactiveTitle: null,
  title: '',
}

const setTitle = (title) => { state.title = title; }
const setInactiveTitle = (inactivetitle) => { state.inactiveTitle = inactivetitle; }

const setInactiveTitleCallback = () => {
  if(document.hidden && state.inactiveTitle){
      document.querySelector("title").textContent = state.inactiveTitle;
  } else {
      document.querySelector("title").textContent = state.title;
  }
}
  
const setup = () => {
  setInactiveTitle(null);
  document.addEventListener("visibilitychange", setInactiveTitleCallback);
}

const destroy = () => {
  setInactiveTitle(null);
  document.removeEventListener("visibilitychange", setInactiveTitleCallback);
}

export const InactiveDetection = {
  setInactiveTitle, setTitle, setup, destroy
}